module.exports = __webpack_public_path__ + "stormwater/connect/font/pwdgrant.svg";